'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { browserTitle, pageNameFor } from '@/lib/naming'

/**
 * Sets the browser tab title to "{Page} · Tender Command Center" on each
 * route change. A record, or any route with no name, keeps the product title.
 */
export function BrowserTitle() {
  const pathname = usePathname()
  useEffect(() => {
    document.title = browserTitle(pageNameFor(pathname ?? '/')?.name)
  }, [pathname])
  return null
}
